import { z } from 'zod/v4';

const TreeNodeDTO = <T extends z.ZodRawShape>(shape: T) =>
  z.object({
    ...shape,
    children: z.lazy(() => z.array(TreeNodeDTO(shape))).optional(), // children are optional in real trees
  });

const TreeSettingsValueShape = {
  node_id: z.string(),
  is_grouped: z.boolean().optional(),
  attribute_settings: z.object({ display: z.array(z.string()) }).optional(),
};

export const TreeSettingsSchemaDTO = TreeNodeDTO(TreeSettingsValueShape);

export type TreeSettingsSchema = z.infer<typeof TreeSettingsSchemaDTO>;